/**
 * xyclient的monaco是一个amd模块并非同步加载，工程中的对monaco的同步调用都应该通过这个函数的回调函数来执行
 * @param callback 建议箭头函数来绑定this
 * @example
 * import monacoProvider from './monacoProvider.js'
 * monacoProvider((monaco) => {
 *    this.diffEditor =  monaco.editor.createDiffEditor(this.$refs.diffContainer);
 * })
 */
export default async function monacoProvider(callback) {
  let monaco = null;
  for (let i = 0; i < 10; i++) {
    try {
      monaco = await new Promise(rs => window.require(['vs/editor/editor.main'], rs));
      if (monaco) {
        break;
      }
    } catch (e) {
      console.log(`Monaco Editor 加载失败[${i}]`);
      await new Promise(rs => setTimeout(rs, 200));
    }
  }
  if (typeof callback === 'function') callback(monaco);
  return monaco;
}
export async function getMonacoAsync() {
  const monaco = await monacoProvider();
  return monaco;
}
//# sourceMappingURL=monacoProvider.js.map
